const MaturityMethods = {
  ARRHENIUS: 'Arrhenius',
  NURSE_SAUL: 'NurseSaul',
};

export default MaturityMethods;
